import React from 'react';
import { autoId, ID_OTP_VERIFICATION, OTPInput } from '@workday/upc-common';
import { Controller, Control } from 'react-hook-form';
import classNames from 'classnames';
import styles from './otp-form-field.module.scss';
import { useTranslation } from 'react-i18next';

export interface PasscodeFormState {
    passcode: string;
}

interface OTPFormFieldProps {
    disabled?: boolean;
    autoFocus: boolean;
    className?: string;
    control: Control<PasscodeFormState>;
    legend?: string;
    legendProps?: React.HTMLAttributes<HTMLLegendElement>;
    legendVisible?: boolean;
    grow?: boolean;
}

const otpErrorMessageId = 'otpErrorMessageId';

export function OTPFormField({
    control,
    disabled,
    autoFocus,
    className,
    legend,
    legendProps,
    legendVisible = false,
    grow = false
}: OTPFormFieldProps) {
    const { t } = useTranslation('shared');

    const labels = [
        t('OTP.inputFirst'),
        t('OTP.inputSecond'),
        t('OTP.inputThird'),
        t('OTP.inputFourth'),
        t('OTP.inputFifth'),
        t('OTP.inputSixth')
    ];

    const classes = classNames(
        styles.otpFormField,
        {
            [styles.grow]: grow
        },
        className
    );

    return (
        <Controller
            rules={{
                required: t('Required.fieldGeneric'),
                minLength: {
                    value: 6,
                    message: t('OTP.passcodeTooShort')
                }
            }}
            control={control}
            name='passcode'
            render={({ field, fieldState }) => {
                return (
                    <fieldset {...autoId(ID_OTP_VERIFICATION)} className={classes}>
                        <legend
                            {...legendProps}
                            className={classNames(legendProps?.className, !legendVisible ? styles.hidden : '')}>
                            {legend ? legend : t('OTP.verificationCode')}
                        </legend>
                        <OTPInput
                            ariaDescribedBy={otpErrorMessageId}
                            autoFocus={autoFocus}
                            disabled={disabled}
                            onChange={field.onChange}
                            value={field.value}
                            labels={labels}
                        />
                        {fieldState.error && (
                            <p id={otpErrorMessageId} className={styles.error}>
                                {fieldState.error.message}
                            </p>
                        )}
                    </fieldset>
                );
            }}
        />
    );
}
